import React, { useContext } from 'react';
import FieldContext from '../../../../FieldContext';
import StyledAddButton from './StyledAddButton';
import { FormattedMessage } from 'react-intl';
import useIsPortfolioReadonly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';

type AddButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

// TODO on mobile devices, this button should read *tap* to add text
const AddButton = ({ onClick }: AddButtonProps) => {
  const field = useContext(FieldContext);
  const portfolioIsReadonly = useIsPortfolioReadonly();

  const showFallbackButtonLabel =
    field.name === null ||
    field.name.trim().length === 0 ||
    field.name.trim().length > 50;

  return (
    <StyledAddButton onClick={onClick} disabled={portfolioIsReadonly}>
      {showFallbackButtonLabel ? (
        <FormattedMessage id="portfolio.challenge.field.add_button_fallback" />
      ) : (
        <FormattedMessage
          id="portfolio.challenge.field.add_button"
          values={{
            fieldName: field.name,
          }}
        />
      )}
    </StyledAddButton>
  );
};

export default AddButton;
